import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import { Box, Paper } from '@mui/material';
import MessagesPaneHeader from '../../components/MessagesPaneHeader';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/AriStore';
import App from '../../document-manager/App';

export default function DocumentManagerPage() {
  const menuInfo = useSelector((state: RootState) => state.menu);

  return (
    <>
      <Sidebar />
      <Header />
      <Box component="main" className="MainContent" sx={{ flex: 1 }}>
        <Paper
          key={menuInfo.selectedIndex}
          sx={{
            height: { xs: '100dvh', lg: '100dvh' },
            display: 'flex',
            flexDirection: 'column',
            pt: { xs: 'var(--Header-height)', sm: 0 },
          }}
        >
          <>
            <MessagesPaneHeader menuTitle={menuInfo.selectedName || '컨텐츠 관리자'} />
            <Box sx={{ flex: 1, height: 'calc(100vh - 120px)', overflow: 'hidden' }}>
              <App />
            </Box>
          </>
        </Paper>
      </Box>
    </>
  );
}


